import { DeletedFileCard } from '../deleted-file-card';
import { Grid } from '@mui/material';
import { styles } from './styles';
import { TProjectDeletedFile } from 'redux-store/api/file-cabinet';

interface IDeletedFileGridView {
  deletedFiles: TProjectDeletedFile[];
  onDeleteFile: (fileId: number) => void;
  onViewFile: (file: TProjectDeletedFile) => void;
  onRestoreFile: (fileId: number) => void;
}

export const DeletedFileGridView = ({
  deletedFiles,
  onDeleteFile,
  onViewFile,
  onRestoreFile,
}: IDeletedFileGridView) => {
  if (!deletedFiles.length) return null;

  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.wrapper}>
        <Grid sx={styles.content}>
          {deletedFiles?.map((file, index) => (
            <DeletedFileCard
              deletedAt={file.deletedAt}
              key={`${file?.id}${index}`}
              type={file?.type}
              mimeType={file?.mimeType}
              name={file?.name}
              size={file?.size}
              onRestoreFile={() => onRestoreFile(file.id)}
              onDeleteFile={() => onDeleteFile(file.id)}
              onViewFile={() => onViewFile(file)}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
